import { ReactNode } from "react";
import usePivotReportData, {
  PivotReportDataContext,
} from "./usePivotReportData";

export interface PivotReportDataProviderProps {
  children?: ReactNode;
}

const PivotReportDataProvider: React.FC<PivotReportDataProviderProps> = ({
  children,
}) => {
  const context = usePivotReportData();

  return (
    <PivotReportDataContext.Provider value={context}>
      {children}
    </PivotReportDataContext.Provider>
  );
};
export default PivotReportDataProvider;
